/**
 * @module events/types/mouseMove
 */

/**
 * @type {string}
 */
export default 'mousemove'